import axios from '../../../axios'


// 获取列表
export const list = (data) => {
  return axios({
    url: '/workorder/woRepairDaily/list',
    method: 'post',
    data
  })
}

export const findById = (data) => {
  return axios({
    url: '/workorder/woRepairDaily/findById',
    method: 'post',
    data
  })
}

//获取车辆类型
export const getVehicleType = (data) => {
  return axios({
    url: '/workorder/woRepairDaily/getVehicleType',
    method: 'post',
    data
  })
}

//获取人工单价
export const getFeePerson = (data) => {
  return axios({
    url: '/workorder/woRepairDaily/getFeePerson',
    method: 'post',
    data
  })
}

// 保存信息
export const save = (data) => {
  return axios({
    url: '/workorder/woRepairDaily/save',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/biz/workorder/woRepairDaily.js